/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShapeComparison = {
    properties: {
        team1Matches: {
            type: 'ShapeComparisonMatchList',
            isRequired: true,
        },
        team2Matches: {
            type: 'ShapeComparisonMatchList',
            isRequired: true,
        },
    },
} as const;
